import { useCallback, useEffect, useState } from 'react';
import { useNotifications } from '../../../hooks/useNotifications';
import { FinalCustomersService } from '../../../services/finalCustomersService';
import { debounceFunction } from '../../../utility/utility';
import { ApplicationsService } from '../../../services/applicationsService';

const useFinalCustomerSettings = (accountId) => {
  const [isLoading, setIsLoading] = useState();
  const { showErrorNotification } = useNotifications();
  const [dataSettings, setDataSettings] = useState();
  const [dataForm, setDataForm] = useState();
  const { showSuccessNotification } = useNotifications();

  const getDataFinalCustomerSettings = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await FinalCustomersService.getFinalCustomerSettings(accountId);
      setDataSettings(data.finalCustomersSettings);
    } catch (error) {
      showErrorNotification({
        title: 'error',
        description: 'errorRetrievingRecords',
      });
    } finally {
      setIsLoading(false);
    }
  }, [showErrorNotification]);

  const updateFinalCustomerSettings = (data) => {
    try {
      showSuccessNotification({
        title: 'success',
        description: 'successUpdatingRecord',
      });
      FinalCustomersService.updateFinalCustomerSettings(accountId, data);
    } catch (error) {
      console.error(error);

      showErrorNotification({
        title: 'error',
        description: 'errorUpdatingRecord',
      });
    }
  };

  const getMobileForm = useCallback(
    debounceFunction(async (idApp) => {
      setIsLoading(true);
      try {
        const { application } = await ApplicationsService.getFormById(idApp);
        setDataForm(application);
      } catch (error) {
        console.error(error);
        showErrorNotification({
          title: 'error',
          description: 'errorRetrievingRecord',
        });
      } finally {
        setIsLoading(false);
      }
    }, 200),
    [],
  );

  useEffect(() => {
    getDataFinalCustomerSettings();
  }, [accountId, getDataFinalCustomerSettings]);

  return {
    getDataFinalCustomerSettings,
    isLoading,
    dataSettings,
    updateFinalCustomerSettings,
    getMobileForm,
    dataForm,
  };
};

export default useFinalCustomerSettings;
